// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresSquareTakeBody = {
  poolId: string;
  gridId: string;
  squareKey: string;
};

export type typeSquaresSquareTakeOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { squareKey: string; mySquareCount: number };
};

export type typeSquaresSquareTakeOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSquareTakeOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSquareTakeOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresSquareTakeBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    squareKey: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "gridId", "squareKey"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresSquareTake(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresSquareTakeBody);
  }

  return async function postSquaresSquareTake(
    payload: typeSquaresSquareTakeBody,
  ): Promise<typeSquaresSquareTakeOutput200 | typeSquaresSquareTakeOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresSquareTake" failed before calling the network. #f0470e2c69f2`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f0470e2c69f2" },
        },
        data: null,
      } as typeSquaresSquareTakeOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/square-take`,
      httpMethod: "POST",
      options,
    })) as typeSquaresSquareTakeOutput200 | typeSquaresSquareTakeOutput400;
  };
}
